import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import api from "./http";
import i18n from "./i18n";
import store from "./store";
import "@/utils/directives"; // 弹框拖拽指令
import "@/utils/drag"; // 拖拽指令
import "@/utils/inputFilter"; // 限制输入框输入指令
import global from "@/utils/global";
import TIPSINFO from "@/utils/tipsInfo";
import toolutil from "@/utils/toolutil";
import ElementUI from "element-ui";
import XyjTable from "@/components/xyjtable/xyjTable";
import concTemplate from "@/components/conc/concTemplate";
import concEcharts from "@/components/concEcharts/concEcharts";
import XyjTableDrag from "@/components/xyjtable/xyjtableDrag";
import XyjTableDragNew from "@/components/xyjtable/xyjtableDragNew";
import Signature from "@/components/Signature/Signature";
import menuRoute from "@/components/xyjMenuRouteDialog/xyjMenuRouteDialog";
import XyjRemoteTable from "@/components/xyjtable/xyjAnotherTable";
import XyjTableWorkFlow from "@/components/xyjtable/xyjTableWorkFlow";
// import writeTable from "@/components/xyjtable/writeTable";
import xyjWorkflowDialog from "@/components/xyjworkflowDialog/xyjworkflowDialog";
import BranchPostDialog from "@/components/BranchPostDialog/BranchPostDialog";
import xyjpostDialog from "@/components/xyjpostDialog/xyjpostDialog";
import xyjdeptDialog from "@/components/xyjdeptDialog/xyjdeptDialog";
import xyjdictDialog from "@/components/xyjdictDialog/xyjdictDialog";
import xyjMenuRouteDialog from "@/components/xyjMenuRouteDialog/xyjMenuRouteDialog";
import FaIconTooltip from "@/components/FaIconTooltip";
import "element-ui/lib/theme-chalk/index.css";
import "font-awesome/css/font-awesome.min.css";
import "@/assets/iconfont/iconfont.css";
import XyjButton from "@/components/XyjButton/XyjButton";
import XyjUpload from "@/components/XyjUpload/XyjUpload";
import WorkFlowClient from "@/components/WorkFlow/WorkFlowClient";
import newWorkFlowClient from "@/components/WorkFlow/newWorkFlowClient";
import map from "@/components/bcomponents/map.js";
import citydata from "@/assets/provinceAndCityData/citydata3.js";
import Echarts from "echarts";
import "echarts/lib/chart/line";
import "echarts/map/js/china";
import "echarts/map/js/world";
import "echarts/map/js/province/henan";
import upload from "@/views/upload/upload";
import download from "@/views/upload/download";
import FormMaking from "@/components/vueformmaking/index.js";
import editor from "@/components/bcomponents/tinymceEditor";
import treeTransfer from "el-tree-transfer";
import DynamicLink from "@/components/vueformmaking/DynamicLink";
import mailTable from "@/components/tableComponent/TableComponent";
import previewTopology from "@/components/topologycomponent/previewTopology";
Vue.use(FormMaking);
import Mqtt from "@/mqtt/mqtt";
import topic from "@/mqtt/topics";
import XyjVueLoader from "../static/XyjVueLoader.js";
import province from "../static/cityData.js";
import areaCity from "../static/areaCity.js";
import axios from "@/http/axios";
import Cookies from "js-cookie";
import jquery from "jquery";
import BScroll from "better-scroll";
import Clipboard from "clipboard";
import { CaseOnly } from "@/mixin/CaseOnlyMixin";
import { Button, DatetimePicker, Area, NumberKeyboard, PasswordInput, Popup, Dialog, RadioGroup, Radio, Swipe, SwipeItem, SwipeCell, ImagePreview, Circle, Picker, IndexBar, IndexAnchor } from "vant";
import "vant/lib/index.css";
import area from "@/utils/area";
import VueLocalForage from "vue-localforage";
import JSZip from "jszip";
import FileSaver from "file-saver";
import * as faceapi from "face-api.js"; // 人脸识别face-api
window.faceapi = faceapi;
import Viewer from "v-viewer"; // 图片预览
import { provinceAndCityData, CodeToText, TextToCode } from "element-china-area-data";// 省市数据
import "viewerjs/dist/viewer.css";
import dplayer from "./components/dplayer/dplayer.vue";
import wangeditor from "./components/xyjCustomWangEditor/customWangEditor.vue";  // 引入wangEditor富文本 czc
import flvjs from "flv.js";
import hlsjs from "hls.js";
import Container from "@/components/vueformmaking/Container"; // 拖拽组件
import { VueJsonp } from "vue-jsonp";// 地图根据经纬度获取地址
import newModelDesign from "@/components/WorkFlow/newModelDesign";// 审批流程设计
import basicsElement from "@/views/ElementSet/BasicsElement";// 基础组件
Vue.component("newModelDesign", newModelDesign);
Vue.component("basicsElement", basicsElement);
window.flvjs = flvjs;
window.hlsjs = hlsjs;
Vue.component("dplayer", dplayer);
Vue.component("Container", Container);
// Vue.component("writeTable", writeTable);
Vue.use(Viewer);
Vue.use(VueLocalForage);
Vue.use(Button)
  .use(DatetimePicker)
  .use(Popup)
  .use(Dialog)
  .use(RadioGroup)
  .use(Radio)
  .use(Swipe)
  .use(SwipeItem)
  .use(ImagePreview)
  .use(PasswordInput)
  .use(NumberKeyboard)
  .use(Area)
  .use(SwipeCell)
  .use(Circle)
  .use(Picker)
  .use(IndexBar)
  .use(VueJsonp)
  .use(IndexAnchor);
/*
* 维旺迪 2022年5月16日17:33:03
* 描述：导出pdf插件
* 版本： 1.0
* */
import htmlToPdf from "@/utils/htmlToPdf";
Vue.use(htmlToPdf);
/*
* 王伟东 2020-4-1 11:59:17
* 描述：滚动插件
* 版本： 1.0
* */
Vue.prototype.$BScroll = BScroll;
/*
* 王伟东 2020-3-28 14:37:44
* 描述：省市区文件
* 版本： 1.0
* */
Vue.prototype.$areaData = area;
/**
 *宋建国：2020/3/20 10:41
 *描述：为组件混入通用代码
 *版本：1.0
 */
import authority from "@/components/appComponents/authorityControl.vue";
import xyjUserDialog from "@/components/xyjUserDialog/xyjUserDialog";
import PopupTreeInput from "@/components/PopupTreeInput";
// 权限控制组件
Vue.component("authority", authority);

Vue.mixin(CaseOnly);
Vue.use(ElementUI);
Vue.use(api);
Vue.component("XyjTable", XyjTable);
Vue.component("concTemplate", concTemplate);
Vue.component("concEcharts", concEcharts);
Vue.component("XyjTableDrag", XyjTableDrag);
Vue.component("XyjTableDragNew", XyjTableDragNew);
Vue.component("Signature", Signature);
Vue.component("XyjRemoteTable", XyjRemoteTable);
Vue.component("treeTransfer", treeTransfer);
Vue.component("XyjTableWorkFlow", XyjTableWorkFlow);
Vue.component("XyjButton", XyjButton);
Vue.component("XyjUpload", XyjUpload);
Vue.component("editor", editor);
Vue.component("WorkFlowClient", WorkFlowClient); // 工作流客户端
Vue.component("newWorkFlowClient", newWorkFlowClient); // 工作流客户端
Vue.component("upload", upload);// 导入模板
Vue.component("download", download);// 下载模板
Vue.component("DynamicLink", DynamicLink);// 生产运行时，动态加载组件
Vue.component("mailTable", mailTable);
Vue.component("previewTopology", previewTopology);
Vue.component("menuRoute", menuRoute);
Vue.component("xyjWorkflowDialog", xyjWorkflowDialog);
Vue.component("xyjUserDialog", xyjUserDialog);
Vue.component("PopupTreeInput", PopupTreeInput);
Vue.component("BranchPostDialog", BranchPostDialog);
Vue.component("xyjpostDialog", xyjpostDialog);
Vue.component("xyjdeptDialog", xyjdeptDialog);
Vue.component("xyjdictDialog", xyjdictDialog);
Vue.component("xyjMenuRouteDialog", xyjMenuRouteDialog);
Vue.component("FaIconTooltip", FaIconTooltip);
Vue.component("wangeditor", wangeditor);

import "bootstrap";
import "bootstrap/js/modal.js";
import "bootstrap/js/dropdown.js";
import "bootstrap/js/tooltip.js";
// import 'bootstrap/dist/css/bootstrap.css'
import "font-awesome/css/font-awesome.css";
import "summernote";
import "summernote/dist/summernote.css";
import "summernote/dist/lang/summernote-zh-CN.js";

Vue.prototype.provinceAndCityData = provinceAndCityData;
Vue.prototype.CodeToText = CodeToText;
Vue.prototype.TextToCode = TextToCode;
Vue.prototype.map = map;
Vue.prototype.citydata = citydata;
Vue.prototype.global = global;
Vue.prototype.$echarts = Echarts;
Vue.prototype.$TINFO = TIPSINFO;
Vue.prototype.$tu = toolutil;
Vue.prototype.axios = axios;
Vue.prototype.Cookies = Cookies;
Vue.prototype.jquery = jquery;
Vue.prototype.province = province;
Vue.prototype.areaCity = areaCity;
Vue.prototype.Clipboard = Clipboard;
Vue.prototype.JSZip = JSZip;
Vue.prototype.FileSaver = FileSaver;
/*
* 王伟东 2020-3-27 18:26:17
* 描述：让地理导航组件显示,并接受要导航的地理位置信息
* 版本：1.0
* */
Vue.prototype.showLocation = function(params) {
  const info = {
    key: "local",
    value: {}
  };
  if (this.$tu.isBlank(params)) {
    this.$store.commit("setApplicationData", info);
  } else if (typeof params !== "object") {
    this.$store.commit("setApplicationData", info);
  } else {
    info.value = params;
    this.$store.commit("setApplicationData", info);
  }
  this.jquery(".MARKUP-XYJ").addClass("showMarkupXYJ");
  this.jquery(".map-link-box").addClass("groupFloat");
};
/*
* 王伟东 2020-3-27 18:26:17
* 描述：让地理导航组件隐藏
* 版本：1.0
* */
Vue.prototype.hideLocation = function() {
  this.$store.commit("setApplicationData", { local: {}});
  this.jquery(".MARKUP-XYJ").removeClass("showMarkupXYJ");
  this.jquery(".map-link-box").removeClass("groupFloat");
};
/*
* 王伟东 2020-3-28 18:26:17
* 描述：显示遮罩
* 版本：1.0
* */
Vue.prototype.showMarkup = function() {
  this.jquery(".MARKUP-XYJ").addClass("showMarkupXYJ");
};
/*
* 王伟东 2020-3-28 18:26:17
* 描述：隐藏遮罩
* 版本：1.0
* */
Vue.prototype.hideMarkup = function() {
  this.jquery(".MARKUP-XYJ").removeClass("showMarkupXYJ");
};
/**
 *宋建国：2020/1/3 15:41
 *描述：远程加载功能
 *版本：1.0
 */
Vue.prototype.$XyjVueLoader = XyjVueLoader;
/**
 *宋建国：2019/11/28 16:58
 *描述：消息通行自定义主题协议
 *版本：1.0
 */

Vue.prototype.$topic = topic;
// 审批转签和驳回弹框
import xyjSelectRejectDialog from "@/components/newWorkflow/xyjSelectRejectDialog";
import TransferSignatureDialog from "@/components/newWorkflow/transferSignatureDialog";
import XyjAgreeDialog from "@/components/newWorkflow/xyjAgreeDialog";
import XyjSelectAgreeDialog from "@/components/newWorkflow/xyjSelectAgreeDialog";
import XyjRejectNextLevel from "@/components/newWorkflow/xyjRejectnextlevel";
import XyjFirstNextLevel from "@/components/newWorkflow/xyjFirstNextLevel";
Vue.component("xyjSelectRejectDialog", xyjSelectRejectDialog);
Vue.component("TransferSignatureDialog", TransferSignatureDialog);
Vue.component("XyjAgreeDialog", XyjAgreeDialog);
Vue.component("XyjSelectAgreeDialog", XyjSelectAgreeDialog);
Vue.component("XyjRejectNextLevel", XyjRejectNextLevel);
Vue.component("XyjFirstNextLevel", XyjFirstNextLevel);
/**
 * @description
 * @author (Set the text for this tag by adding docthis.authorName to your settings file.)
 * @date 2020-10-19
 * @param { number } type 1 localStorage 2 sessionStorage
 * @param { string } key 键
 * @param { string } data 要存储的数据
 * @returns
 */
Vue.prototype.$addStorageEvent = function(type, key, data) {
  if (type === 1) {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function(k, val) {
        localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent("setItem", false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, data);
  } else {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: function(k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent("setItem", false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    };
    return storage.setItem(key, data);
  }
};
Vue.prototype.$bus = new Vue(); // event Bus 用于无关系组件间的通信。

const tmpmqtt = new Mqtt.CreateMqtt(global.websocket.hostIp, global.websocket.Port);
Vue.prototype.$mqtt = tmpmqtt;
window.$mqtt = tmpmqtt;
// 日期格式化
// {
//   '年-月-日 时：分：秒': new Date().format("yyyy-MM-dd hh:mm:ss") ,
//   '年-月-日': new Date().format("yyyy-MM-dd") ,
//   '（指定日期）年-月-日': new Date(new Date(time)).getTime()).format("yyyy-MM-dd") ,
// }
// eslint-disable-next-line no-extend-native
Date.prototype.format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1,                 // 月份
    "d+": this.getDate(),                    // 日
    "h+": this.getHours(),                   // 小时
    "m+": this.getMinutes(),                 // 分
    "s+": this.getSeconds(),                 // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    "S": this.getMilliseconds()             // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
};
window.xyjVue = new Vue({
  el: "#app",
  i18n,
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js